import { css } from '@emotion/react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import { useAppDispatch } from 'redux/store';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import { bulkEnrollMentoringProgramRecruitmentApplications } from 'redux/actions/mentoring-program-recruitments';
import { config } from '@config/pendo.config.json';
import { CellProps } from './types';


const styles = css`
  .add-individual-target {
    opacity: 0;
    flex-shrink: 0;
  }
`;

const AddButtonCell = (props: CellProps) => {
  const { className } = props;
  const application = props.cell.getValue();
  const { meta } = props.cell.getContext().table.options;
  const roleFilter = meta?.roleFilter();
  const activeRecruitmentId = meta?.activeRecruitmentId();

  const dispatch = useAppDispatch();
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: programId } = mentoringProgram || {};
  const mentoringProgramAliases = useSelector((state) => getMentoringProgramAliases(state, programId));

  const handleAddParticipant = () => {
    dispatch(bulkEnrollMentoringProgramRecruitmentApplications({
      programId,
      recruitmentId: activeRecruitmentId,
      applicationIds: [application.id],
      ...mentoringProgramAliases,
    }));
  };

  return (
    <div css={styles} className={className}>
      <Button
        variant='outline-primary'
        className='add-individual-target'
        onClick={handleAddParticipant}
        data-qa={`${config.pendo.athena.mentorshipProgram.recruitment.addSingleUserButton}_${application.id}`}
      >
        {roleFilter === 'mentee'
          ? t.MENTORING_PROGRAMS.RECRUITMENT.ADD_AS_MENTEE(mentoringProgramAliases)
          : t.MENTORING_PROGRAMS.RECRUITMENT.ADD_AS_MENTOR(mentoringProgramAliases)}
      </Button>
    </div>
  );
};

export default AddButtonCell;
